import React, {
    useState,
    useEffect
} from "react";

import {TAB_GRADIENT} from "../../../constants/colors";


export default function UtilisationKpiBoxDuo({
    title1,
    title2,
    figure1,
    figure2,
    width,
    color
})
{
    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [displayFigure1, setDisplayFigure1] =
        useState("");

    const [displayFigure2, setDisplayFigure2] =
        useState("");


    //--------------------------------------------------------
    // Values
    //--------------------------------------------------------

    useEffect(
        () =>
        {
            if(
                figure1 !== undefined
                &&
                figure1 !== null
            )
            {
                setDisplayFigure1(
                    figure1
                );
            }

            if(
                figure2 !== undefined
                &&
                figure2 !== null
            )
            {
                setDisplayFigure2(
                    figure2
                );
            }
        },
        [
            figure1,
            figure2
        ]
    );


    //========================================================
    // Styles
    //========================================================

    //--------------------------------------------------------
    // KPI
    //--------------------------------------------------------

    const thisContainer =
    {
        display:
            "flex",

        width:
            width || "100%",

        height:
            "60px",

        boxSizing:
            "border-box",

        //----------------------------------------------------
        // Structural graphite
        //----------------------------------------------------

        background:
            TAB_GRADIENT,

        //----------------------------------------------------
        // Structural = square
        //----------------------------------------------------

        borderRadius:
            "0px",

        border:
            "1px solid rgba(255,255,255,0.07)",

        boxShadow:
            "0 2px 5px rgba(0,0,0,0.16)",

        color:
            "white",

        overflow:
            "hidden"
    };


    //--------------------------------------------------------
    // Figures
    //--------------------------------------------------------

    const doubleFigureContainer =
    {
        display:
            "flex",

        width:
            "100%",

        height:
            "100%"
    };


    //--------------------------------------------------------
    // Figure
    //--------------------------------------------------------

    const figureContainer =
    {
        display:
            "flex",

        width:
            "50%",

        height:
            "100%",

        flexDirection:
            "column",

        alignItems:
            "center",

        justifyContent:
            "center",

        boxSizing:
            "border-box"
    };


    //--------------------------------------------------------
    // Second figure
    //--------------------------------------------------------

    const secondFigureContainer =
    {
        ...figureContainer,

        borderLeft:
            "1px solid rgba(255,255,255,0.08)"
    };


    //--------------------------------------------------------
    // Title
    //--------------------------------------------------------

    const titleContainer =
    {
        display:
            "flex",

        width:
            "100%",

        height:
            "26px",

        minHeight:
            "26px",

        alignItems:
            "center",

        justifyContent:
            "center",

        padding:
            "0 8px",

        boxSizing:
            "border-box",

        fontSize:
            "13px",

        fontWeight:
            500,

        color:
            "rgba(255,255,255,0.76)",

        borderBottom:
            "1px solid rgba(255,255,255,0.07)"
    };


    //--------------------------------------------------------
    // Figure value
    //--------------------------------------------------------

    const figureValueContainer =
    {
        display:
            "flex",

        flex:
            "1",

        width:
            "100%",

        alignItems:
            "center",

        justifyContent:
            "center",

        fontSize:
            "21px",

        fontWeight:
            500,

        color:
            color || "#45afe0",

        lineHeight:
            "1"
    };


    //========================================================
    // Render
    //========================================================

    return (

        <div
            style={
                thisContainer
            }
        >

            <div
                style={
                    doubleFigureContainer
                }
            >

                <div
                    style={
                        figureContainer
                    }
                >

                    <div
                        style={
                            titleContainer
                        }
                    >
                        {title1}
                    </div>

                    <div
                        style={
                            figureValueContainer
                        }
                    >
                        {displayFigure1}
                    </div>

                </div>


                <div
                    style={
                        secondFigureContainer
                    }
                >

                    <div
                        style={
                            titleContainer
                        }
                    >
                        {title2}
                    </div>

                    <div
                        style={
                            figureValueContainer
                        }
                    >
                        {displayFigure2}
                    </div>

                </div>

            </div>

        </div>

    );
}